type EmailService = "gmail" | "outlook" | "yahoo" | "default";

interface EmailTemplate<TData> {
  getSubject: (row: TData) => string;
  getBody: (row: TData) => string;
}

export const useEmailHandler = <TData>(emailTemplate?: EmailTemplate<TData>, rowData?: TData) => {
  const getEmailContent = () => {
    if (!emailTemplate || !rowData) {
      return {
        subject: "Email from LCT",
        body: "",
      };
    }

    return {
      subject: emailTemplate.getSubject(rowData),
      body: emailTemplate.getBody(rowData),
    };
  };

  const handleSendEmail = (email: string, service?: EmailService) => {
    const { subject, body } = getEmailContent();
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    switch (service) {
      case "gmail":
        window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodedSubject}&body=${encodedBody}`, "_blank");
        break;
      case "outlook":
        window.open(`https://outlook.live.com/mail/0/deeplink/compose?to=${email}&subject=${encodedSubject}&body=${encodedBody}`, "_blank");
        break;
      case "yahoo":
        window.open(`https://compose.mail.yahoo.com/?to=${email}&subject=${encodedSubject}&body=${encodedBody}`, "_blank");
        break;
      default:
        window.location.href = `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
    }
  };

  return {
    handleSendEmail,
  };
};
